<div class="ui-g ui-fluid">
  <div class="ui-g-12 ui-lg-12">
    <div class="card card-w-title" *ngIf="accessDetail && !accessDetail.hasAccess">
      <h1>Access Denied</h1>
    </div>
    <div class="card card-w-title" *ngIf="accessDetail && accessDetail.hasAccess">
      <h1>{{ title }}</h1>
      <form [formGroup]="driverForm" (ngSubmit)="save(driverForm.value)" autocomplete="off">
        <div class="ui-grid-row">
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4"><label>First Name</label></div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="firstName"
                formControlName="firstName"
                maxlength="20"
                class="form-component"
              />
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4"><label>Surname</label></div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="surname"
                formControlName="surname"
                maxlength="20"
                class="form-component"
              />
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4"><label>Nick Name</label></div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="nickName"
                formControlName="nickName"
                maxlength="20"
                class="form-component"
              />
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4"><label>Mobile Number</label></div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="mobileNumber"
                [disabled]="disabled"
                formControlName="mobileNumber"
                maxlength="20"
                class="form-component"
              />
            </div>
          </div>
        </div>
        <div class="ui-grid-row">
          <div class="ui-g-6 ui-sm-12">
            <div class="ui-grid-col-4"><label>Driving Licence Number</label></div>
            <div class="ui-grid-col-8">
              <input
                pInputText
                id="drivingLicenceNumber"
                formControlName="drivingLicenceNumber"
                maxlength="16"
                class="form-component"
              />
            </div>
          </div>
        </div>

        <div class="ui-grid-row">
          <button
            type="button"
            (click)="Cancel()"
            pButton
            icon="fa ui-icon-close"
            label="Cancel"
            class="btn-to-right"
          ></button>
          <button
            type="button"
            (click)="ResetCode()"
            pButton
            label="Reset Code"
            class="green-btn btn-to-right"
            *ngIf="id != 0"
            [disabled]="isSupplierIndividual"
            pTooltip="Reset the driver's SMS PIN code"
          ></button>
          <button
            type="submit"
            class="green-btn btn-to-right"
            pButton
            icon="fa ui-icon-check"
            label="Save"
            [disabled]="!driverForm.valid"
          ></button>
        </div>
      </form>
    </div>
  </div>
</div>
